module.exports = __webpack_public_path__ + "static/media/rejectPost.7b31b597.svg";